import { Injectable } from '@angular/core';
import { RouterModule, CanLoad, Router, Route } from '@angular/router';

import { Observable, of } from 'rxjs';
import { LoginComponent } from '../pages/login/login.component';
import { AuthGuard } from '../auth/auth-guard.service';
import { AuthService } from '../auth/auth.service';
import { DashboardModule } from '../pages/dashboard/dashboard.module';
import { PasswordResetDashComponentModule } from '../pages/password-reset/password-reset-dash/password-reset-dash.module';
import { TraineeSearchModule } from '../pages/trainee-search/trainee-search.module';
import { TrainerDashboardModule } from '../pages/trainer-dashboard/trainer-dashboard.module';
import { TraineeDashboardModule } from '../pages/trainee-dashboard/trainee-dashboard.module';

@Injectable()
export class CanLoadDashboardSection implements CanLoad {
	constructor(private authService: AuthService, private router: Router) {}

	canLoad(route: Route): Observable<boolean> {
		if (this.authService.getIsLoggedIn()) return of(true);

		// Navigate to the login page
		this.router.navigate([ '/login' ]);
		return of(false);
	}
}

export const appRoutingProviders: any = [ AuthGuard, AuthService ];

export const routing = RouterModule.forRoot(
	[
		{ path: '', pathMatch: 'full', redirectTo: '/login' },
		{ path: 'login', component: LoginComponent },
		{
			path: 'traineeDashboard',
			loadChildren: () =>
				import('../../app/pages/trainee-dashboard/trainee-dashboard.module').then(
					(m) => m.TraineeDashboardModule
				),
			canLoad: [ CanLoadDashboardSection ]
		},
		{
			path: 'trainerDashboard',
			loadChildren: () =>
				import('../../app/pages/trainer-dashboard/trainer-dashboard.module').then(
					(m) => m.TrainerDashboardModule
				),
			canLoad: [ CanLoadDashboardSection ]
		},
		{
			path: 'traineeSearch',
			loadChildren: () =>
				import('../../app/pages/trainee-search/trainee-search.module').then((m) => m.TraineeSearchModule)
		},

		{
			// path:'dashboard',loadChildren:'app/pages/dashboard/dashboard.module#',

			path: 'dashboard',
			loadChildren: () => import('../../app/pages/dashboard/dashboard.module').then((m) => m.DashboardModule),

			canLoad: [ CanLoadDashboardSection ]
		},
		{
			path: 'resetPasswordDash',
			loadChildren: () =>
				import('../../app/pages/password-reset/password-reset-dash/password-reset-dash.module').then(
					(m) => m.PasswordResetDashComponentModule
				)
		}
	],
	{ useHash: true, relativeLinkResolution: 'legacy' }
);
